const INIT_STATE = {
  picked: [],
  packed: [],
  shipped: [],
  reject: [],
  assign_wave: false,
  hold: false,
  unhold: false,
  shipping_orders: false,
  orders: [],
  progress_total: null,
};

export default function loadingReducer(state = INIT_STATE, action) {
  const { data } = action;
  switch (action.type) {
    case '@oms/CLEAR_OMS_LOADING': {
      return INIT_STATE;
    }

    case '@oms/SHIP_ORDERS_LOADING': {
      return {
        ...state,
        shipping_orders: true,
      };
    }

    case '@oms/ASSIGN_WAVE_LOADING': {
      return {
        ...state,
        assign_wave: true,
      };
    }

    case '@oms/HOLD_ORDER_LOADING': {
      return {
        ...state,
        hold: true,
      };
    }

    case '@oms/UNHOLD_ORDER_LOADING': {
      return {
        ...state,
        unhold: true,
      };
    }

    case '@oms/PICK_ORDER_LOADING': {
      return {
        ...state,
        picked: data.map((d) => d.id),
      };
    }

    case '@oms/PACK_ORDER_LOADING': {
      return {
        ...state,
        packed: data.map((d) => d.id),
      };
    }

    case '@oms/SHIP_ORDER_LOADING': {
      return {
        ...state,
        shipped: data.map((d) => d.id),
      };
    }
    case '@oms/REJECT_ORDER_LOADING': {
      return {
        ...state,
        reject: data.map((d) => d.id),
      };
    }

    default:
      return state;
  }
}
